// extracted by mini-css-extract-plugin
module.exports = {"header":"HeroLogo_header__Fyc1x","logo":"HeroLogo_logo__RWTYm","title":"HeroLogo_title__bgDoe"};